import MuiAvatar from '@zenbusiness/zui/Avatar';
import { superstyled } from '@zenbusiness/zui/styles';

export const Content = superstyled({
  name: 'Content',
  slot: 'Root',
  styles: ({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(4),
    },
  }),
});

export const Avatar = superstyled({
  name: 'Avatar',
  slot: 'Root',
  tag: MuiAvatar,
  propsAdded: {
    variant: 'square',
  },
  styles: ({ theme }) => ({
    border: 'none',
    borderRadius: theme.shape.rounded.md,
    backgroundColor: theme.palette.primary.light,
    height: '2.5rem',
    width: '2.5rem',
  }),
});

export const ProfileWrapper = superstyled({
  name: 'ProfileWrapper',
  slot: 'Root',
  styles: ({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(4),
    },
  }),
});

export const TextContainer = superstyled({
  name: 'TextContainer',
  slot: 'Root',
  styles: () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }),
});
